import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      overflow: 'hidden',
      gap: ({ flexGap }) => flexGap,

      '&$expanded': {
        flexWrap: 'wrap',
        overflow: 'visible',
      },
    },
    expanded: {},

    childWrapper: {
      flexShrink: 0,
      visibility: 'collapse',

      '&$visible': {
        visibility: 'visible',
      },
    },
    visible: {},

    button: {
      minWidth: 'auto',
      padding: theme.spacing(0.625, 1),
      border: theme.shape.borderGray70,
      ...theme.typography.regular12,
      color: COLORS.gray.black,
      fontWeight: theme.typography.fontWeightRegular,
    },
    buttonMore: {
      position: 'absolute',
    },
    buttonLess: {},
  }),
  { name: 'OverflowItems' }
);
